import { MatTabsModule } from "@angular/material/tabs";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";

import { HighlightModule, HIGHLIGHT_OPTIONS } from "ngx-highlightjs";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// layouts
import { AdminComponent } from "./layouts/admin/admin.component";
import { AppsComponent } from "./layouts/apps/apps.component";
import { AuthComponent } from "./layouts/auth/auth.component";

// admin views
import { DashboardComponent } from "./views/admin/dashboard/dashboard.component";
import { MapsComponent } from "./views/admin/maps/maps.component";
import { TablesComponent } from "./views/admin/tables/tables.component";

// auth views
import { LoginComponent } from "./views/auth/login/login.component";
import { RegisterComponent } from "./views/auth/register/register.component";

// apps views
import { NewsAnalyzerComponent } from "./views/apps/news-analyzer/news-analyzer.component";
import { TopicsAnalyzerComponent } from "./views/apps/topics-analyzer/topics-analyzer.component";

// no layouts views
import { IndexComponent } from "./views/index/index.component";
import { LandingComponent } from "./views/landing/landing.component";
import { ServiceDetailViewComponent } from "./views/service_detail_view/service_detail_view.component";

// components for views and layouts

import { AdminNavbarComponent } from "./components/navbars/admin-navbar/admin-navbar.component";
import { AuthNavbarComponent } from "./components/navbars/auth-navbar/auth-navbar.component";
import { FooterAdminComponent } from "./components/footers/footer-admin/footer-admin.component";
import { FooterComponent } from "./components/footers/footer/footer.component";
import { FooterSmallComponent } from "./components/footers/footer-small/footer-small.component";
import { IndexNavbarComponent } from "./components/navbars/index-navbar/index-navbar.component";
import { MapExampleComponent } from "./components/maps/map-example/map-example.component";
import { IndexDropdownComponent } from "./components/dropdowns/index-dropdown/index-dropdown.component";
import { TableDropdownComponent } from "./components/dropdowns/table-dropdown/table-dropdown.component";
import { PagesDropdownComponent } from "./components/dropdowns/pages-dropdown/pages-dropdown.component";
import { NotificationDropdownComponent } from "./components/dropdowns/notification-dropdown/notification-dropdown.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { UserDropdownComponent } from "./components/dropdowns/user-dropdown/user-dropdown.component";
import { ContactComponent } from "./components/contact/contact.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ThreeServiceCardsComponent } from "./views/landing/three-service-cards/three-service-cards.component";
import { ServicesComponent } from "./views/services/services.component";

import { MarkdownModule } from "ngx-markdown";
import {
  SvgFillMaskComponent,
  SvgQuestionAnsweringComponent,
  SvgSummaryComponent,
  SvgTextClassificationComponent,
  SvgTableQnAComponent,
  SvgTextGenerationComponent,
  SvgText2TextGenerationComponent,
  SvgTokenClassificationComponent,
  SvgTranslationComponent,
  SvgZeroShotClassComponent,
  SvgSelectorComponent,
  SvgTaskSelectorComponent,
  SvgImgSegmentationComponent,
} from "./components/svg/svg.component";
import { ServiceItemCardComponent } from "./views/services/service-item-card/service-item-card.component";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SearchPipe } from "src/app/pipes/search.pipe";
import { ServiceStatsAndTestComponent } from "./views/service_detail_view/service-stats-and-test/service-stats-and-test.component";
import { LittleServiceCardComponent } from "./views/landing/little-service-card/little-service-card.component";

import { HttpClientModule } from "@angular/common/http";
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from "ngx-google-analytics";
import { DependencyDashboardComponent } from './components/dependency-dashboard/dependency-dashboard.component';
import { TextSummaryComponent } from './views/apps/text-summary/text-summary.component';
import { ImageGenerationComponent } from "./views/apps/image-generation/image-generation.component";
import { NewsGenerationBaseballComponent } from './views/apps/news-generation-baseball/news-generation-baseball.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { SearchGamePipe } from "./views/apps/news-generation-baseball/search-game.pipe";
import { ImageCarouselComponent } from "./components/image-carousel/image-carousel.component"

import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { CommentsExplorerComponent } from "./components/comments-explorer/comments-explorer.component";
import { DialogRectifySentimentComponent } from "./components/dialog-rectify-sentiment/dialog-rectify-sentiment";
import { DialogRectifyTopicComponent } from "./components/dialog-rectify-topic/dialog-rectify-topic";


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    IndexDropdownComponent,
    PagesDropdownComponent,
    TableDropdownComponent,
    NotificationDropdownComponent,
    UserDropdownComponent,
    SidebarComponent,
    FooterComponent,
    FooterSmallComponent,
    FooterAdminComponent,
    MapExampleComponent,
    AuthNavbarComponent,
    AdminNavbarComponent,
    IndexNavbarComponent,
    AdminComponent,
    AppsComponent,
    NewsAnalyzerComponent,
    TopicsAnalyzerComponent,
    AuthComponent,
    MapsComponent,
    TablesComponent,
    LoginComponent,
    RegisterComponent,
    IndexComponent,
    ServiceDetailViewComponent,
    LandingComponent,
    ContactComponent,
    ThreeServiceCardsComponent,
    SvgFillMaskComponent,
    SvgQuestionAnsweringComponent,
    SvgSummaryComponent,
    SvgTextClassificationComponent,
    SvgTableQnAComponent,
    SvgTextGenerationComponent,
    SvgText2TextGenerationComponent,
    SvgTokenClassificationComponent,
    SvgTranslationComponent,
    SvgZeroShotClassComponent,
    SvgSelectorComponent,
    SvgTaskSelectorComponent,
    SvgImgSegmentationComponent,
    ServicesComponent,
    ServiceItemCardComponent,
    SearchPipe,
    SearchGamePipe,
    ServiceStatsAndTestComponent,
    LittleServiceCardComponent,
    DependencyDashboardComponent,
    TextSummaryComponent,
    NewsGenerationBaseballComponent,
    ImageGenerationComponent,
    CarouselComponent,
    ImageCarouselComponent,
    DialogRectifyTopicComponent,
    DialogRectifySentimentComponent,
    CommentsExplorerComponent
  ],
  imports: [
    BrowserModule,
    NgxGoogleAnalyticsModule.forRoot("G-CKZECP0NEQ"),
    NgxGoogleAnalyticsRouterModule,
    AppRoutingModule,
    MatTabsModule,
    MatSliderModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    HighlightModule,
    MarkdownModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatTableModule,
    MatDialogModule,
  ],
  exports: [
    SearchPipe
  ],
  providers: [
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        lineNumbers: true,
        fullLibraryLoader: () => import("highlight.js"),
        lineNumbersLoader: () => import("highlightjs-line-numbers.js"),
      }
    }
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
